import { z } from 'zod';

/** Приёмка поставки на площадке по строке графика договора (ПР-08) */
export const SiteDeliveryAcceptInput = z.strictObject({
  receivedQuantity: z.number().positive().finite(),
  waybillNumber: z.string().trim().max(120).nullable().optional(),
  /** Есть паспорт / сертификат качества */
  passportPresent: z.boolean(),
  note: z.string().trim().max(2000).nullable().optional(),
  /** Уже загруженные и готовые fileId фото приёмки */
  photoFileIds: z.array(z.uuid()).max(20).default([]),
});
export type SiteDeliveryAcceptInput = z.infer<typeof SiteDeliveryAcceptInput>;

export interface SiteDeliveryAcceptance {
  id: string;
  projectId: string;
  contractId: string;
  scheduleRowId: string;
  supplierId: string | null;
  receivedQuantity: number;
  waybillNumber: string | null;
  passportPresent: boolean;
  note: string | null;
  photoFileIds: string[];
  remarkId: string | null;
  acceptedBy: string;
  acceptedAt: string;
}

/**
 * Команда приёмки с телефона (ПМ-09): постоянный ключ повтора. Повтор с тем же ключом возвращает прежний результат,
 * а не «поставка уже принята»; заголовок Idempotency-Key равен clientOperationId.
 */
export const SiteDeliveryAcceptCommand = z.strictObject({
  clientOperationId: z.uuid(),
  expectedRevision: z.literal(0),
  payload: SiteDeliveryAcceptInput,
});
export type SiteDeliveryAcceptCommand = z.infer<typeof SiteDeliveryAcceptCommand>;

/** Квитанция без свободного текста и количеств: только ссылки на созданные записи */
export const SiteDeliveryAcceptResult = z.strictObject({
  id: z.uuid(),
  scheduleRowId: z.uuid(),
  remarkId: z.uuid().nullable(),
});
export type SiteDeliveryAcceptResult = z.infer<typeof SiteDeliveryAcceptResult>;
export const SiteDeliveryAcceptAck = z.strictObject({
  receiptId: z.uuid(),
  replayed: z.boolean(),
  result: SiteDeliveryAcceptResult,
});
export type SiteDeliveryAcceptAck = z.infer<typeof SiteDeliveryAcceptAck>;
